import { NavLink } from 'react-router-dom';
import styles from '@/styles/components/BottomNav.module.css';

const navItems = [
  { to: '/', label: 'Home', icon: '🏠', ariaLabel: 'Home' },
  { to: '/recipe', label: 'Recipe', icon: '📖', ariaLabel: 'Recipe' },
  { to: '/schedule', label: 'Schedule', icon: '📅', ariaLabel: 'Schedule' },
  { to: '/settings', label: 'Settings', icon: '⚙', ariaLabel: 'Settings' },
];

export function BottomNav() {
  return (
    <nav className={styles.nav} aria-label="Main navigation">
      {navItems.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.to === '/'}
          className={({ isActive }) =>
            `${styles.navItem} ${isActive ? styles.active : styles.inactive}`
          }
          aria-label={item.ariaLabel}
        >
          {({ isActive }) => (
            <>
              <span className={styles.navIcon} aria-hidden="true">
                {item.icon}
              </span>
              <span className={styles.navLabel} aria-current={isActive ? 'page' : undefined}>
                {item.label}
              </span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
